import { arrow, flip, FloatingArrow, offset, shift, useFloating } from '@floating-ui/react';
import { useOuterClickNotifier } from '@medly-components/utils';
import { ScatterPlotDatum, ScatterPlotTooltipProps } from '@nivo/scatterplot';
import { ReactNode, useContext, useRef } from 'react';
import { ScatterPlotContext } from '../ScatterPlotContext';
import { TooltipContentWrapper, TooltipWrapper } from './Tooltip.styled';

type ITooltipProps<RawDatum extends ScatterPlotDatum> = ScatterPlotTooltipProps<RawDatum> & {
    content: (node: any) => ReactNode;
};

export const Tooltip = <RawDatum extends ScatterPlotDatum>({ node, content }: ITooltipProps<RawDatum>) => {
    const arrowRef = useRef(null);
    const { currentTooltip, setCurrentToolTip } = useContext(ScatterPlotContext);
    const { refs, floatingStyles, context } = useFloating({
        placement: 'top',
        middleware: [
            offset(10),
            flip(),
            shift(),
            arrow({
                element: arrowRef
            })
        ]
    });

    useOuterClickNotifier(() => arrowRef.current && setCurrentToolTip({}), arrowRef);

    if ((node?.data as any)?.id === currentTooltip?.data?.id) {
        return (
            <>
                <TooltipWrapper ref={refs.setReference} />
                <TooltipContentWrapper ref={refs.setFloating} style={floatingStyles}>
                    {content(node)}
                    <FloatingArrow ref={arrowRef} context={context} fill="white" />
                </TooltipContentWrapper>
            </>
        );
    }
    return null;
};
